module.exports = __webpack_public_path__ + "static/media/game-credit-unsplash.f42281da.png";